export interface VcuDevice {
  id: string;                       // UUID (tb_vcu.id_vcu)
  serialNumber: string;             // tb_vcu.st_serial_number
  nickname: string | null;          // tb_vcu.st_nickname
  vehicleModel: string | null;     // tb_vcu_attribute: "vehicle-model" (ex: "FT700")
  modelCode: string | null;        // tb_vcu_attribute: "model" (ex: "1A") — interno, não exibir
  modelDescription: string | null; // tb_vcu_model_i18n.st_description (ex: "FT700")
  version: string | null;          // tb_vcu_attribute: "version" (ex: "4.3.0")
  hwVersion: string | null;        // tb_vcu_attribute: "hw_version" (ex: "2.1")
  status: string;                  // tb_vcu.en_status ("AC" = ativo, "DI" = desativado)
  createdAt: string;               // tb_vcu.ts_created (ISO 8601)
  lastAccess: string | null;       // tb_vcu.ts_last_access (ISO 8601)
}

export interface VcuListResponse {
  vcus: VcuDevice[];
}

export interface PairGenerateResponse {
  pairCode: string;
  expiresAt: string;               // ISO 8601
  expiresInSeconds: number;
}

export interface VcuUpdateRequest {
  nickname: string;
}

export interface VcuUnpairResponse {
  message: string;
}

export interface VcuApiError {
  error: 'TOO_MANY_REQUESTS' | 'ALREADY_PAIRED' | 'NOT_FOUND' | 'FORBIDDEN' | 'USER_NOT_FOUND' | 'INTERNAL_ERROR' | 'UNAUTHORIZED';
  message: string;
}

/**
 * Retorna o serial saneado, ou `null` quando o valor é inválido/corrompido.
 * Considera inválido: vazio/só espaços, ou contendo o caractere de substituição
 * Unicode (code point 65533) / caracteres de controle não-imprimíveis (0–31, 127)
 * — sintoma de encoding quebrado vindo do dispositivo. Nesses casos o caller
 * deve exibir um texto amigável ("Sem número de série") em vez do lixo.
 */
export function sanitizeSerialNumber(serial: string | null | undefined): string | null {
  if (!serial) return null;
  const trimmed = serial.trim();
  if (!trimmed) return null;
  for (let i = 0; i < trimmed.length; i++) {
    const code = trimmed.charCodeAt(i);
    const isReplacementChar = code === 65533; // U+FFFD "�"
    const isControlChar = code < 32 || code === 127;
    if (isReplacementChar || isControlChar) return null;
  }
  return trimmed;
}
